import React, { useEffect } from "react";
import UserWrapper from "./user.style";
import PageTitle from "components/common/PageTitle";
import { connect } from "react-redux";
import StampTable from "components/user/StampTable";

const UserStamp = props => {
  return (
    <UserWrapper {...props}>
      <div className="pos-relative">
        <PageTitle
          title={"sidebar.user"}
          className="plr-15"
          breadCrumb={[
            {
              name: "sidebar.dashboard"
            },
            {
              name: "sidebar.user"
            },
            {
              name: "user.stamp"
            }
          ]}
        />
        <div
          className="back-icon fs-15 demi-bold-text cursor-pointer"
          onClick={() => props.history.push("/user")}
        >
          <i className="fas fa-step-backward"></i> Backward
        </div>
      </div>
      <div className="user-tbl">
        <StampTable {...props} />
      </div>
    </UserWrapper>
  );
};

const mapStateToProps = state => {
  return {
    ...state.themeChanger,
    ...state.storeID
  };
};

export default connect(mapStateToProps, null)(UserStamp);
